import ApiConstant from "../../constants/api.constants";
import { CustomerExecutiveFilterDTO, ExecutiveInfoDTO, PaginatedCustomerExecutiveDTO } from "../../models/CustomerExecutive/CustomerExecutive-model";
import api from "../api";

 export const getCustomerExecutiveList = async () => {
  try {
    const result = await api
      .get(ApiConstant.GetCustomerExecutiveList, {})
      .then((response: any) => {
        if (response) return response.data;
        else return null;
      })
      .catch((error: any) => {
        console.error('Error reading customer executive list.', error);
      });

    const response = result !== null ? result : null;
    return response;
  } catch (e) {
    console.log('Error in getCustomerExecutiveList API.');
    return [];
  }
};


export const getCustomerExecutiveAssignments = async (
  filter: CustomerExecutiveFilterDTO
): Promise<PaginatedCustomerExecutiveDTO> => {
  try {
    const hasFilters =
      filter.customerId !== null && filter.customerId !== undefined ||
      filter.salesExecutiveIds !== null && filter.salesExecutiveIds  !== undefined;

    const payload = {
      pageNumber: filter.pageNumber,
      pageSize: filter.pageSize,
      sortDirection: filter.sortDirection, 
      ...(hasFilters && {
        customerId: filter.customerId,
        salesExecutiveIds: filter.salesExecutiveIds,
        unassignedOnly: filter.unassignedOnly ?? null,
         ...(filter.endDate && { startDate: filter.endDate }),
      ...(filter.endDate && { endDate: filter.endDate })
      })
    };
    const response = await api.post(ApiConstant.GetCustomerExecutiveAssignments, filter); 
    return {
      totalRecords: response.data?.totalRecords || 0,
      customerExecutiveList: response.data?.customerExecutiveList || []
    };
  } catch (error) {
    console.error("Error fetching customer executive assignments:", error);
    return {
      totalRecords: 0,
      customerExecutiveList: []
    };
  }
};

const updateCustomerExecutive = async (data: { customerId: number; salesExecutiveId: number }) => {
    try {
        const res: any = await api
            .put(ApiConstant.UpdateCustomerExecutive, data)
            .then((result: any) => {
                if (result)            
                    return result.data;
                else
                    return null;         
            })
            .catch(function (error: any) {
                console.error('Error updating customer executive:', error);
            });

        const response = res != null ? res : null;        
        return response;
    } catch (error) {
        console.log('Unexpected error in updateCustomerExecutive:', error);
        return null;
    }
};

const normalizeExecutiveInfo = (input: any): ExecutiveInfoDTO | null => {
  if (!input) return null;

  const data = Array.isArray(input) ? input.find(Boolean) : input;
  if (!data || typeof data !== "object") return null;

  const executiveName =
    data.executiveName ??
    data.salesExecutiveName ??
    data.customerExecutiveName ??
    data.executive?.executiveName ??
    data.executive?.name ??
    data.executiveNameText;

  const executivePhoneNumber =
    data.executivePhoneNumber ??
    data.salesExecutivePhoneNumber ??
    data.customerExecutivePhoneNumber ??
    data.executive?.executivePhoneNumber ??
    data.executive?.phoneNumber ??
    data.executivePhone;

  if (!executiveName && !executivePhoneNumber) return null;

  return {
    executiveName: executiveName ?? "",
    executivePhoneNumber: executivePhoneNumber ?? "",
  };
};

export const getAssignedExecutive = async (
  customerId?: number
): Promise<ExecutiveInfoDTO | null> => {
  try {
    const response = await api.get(ApiConstant.GetCustomerAssignedExecutive, {
      params: customerId ? { customerId } : undefined,
    });
    const raw = response?.data;
    const payload =
      raw?.data ?? raw?.result ?? raw?.executiveInfo ?? raw?.executive ?? raw;

    return normalizeExecutiveInfo(payload);
  } catch (error) {
    console.error("Error fetching assigned executive:", error);
    return null;
  }
};

const CustomerExecutiveService = {
    getCustomerExecutiveList,
    getCustomerExecutiveAssignments,
    updateCustomerExecutive,
    getAssignedExecutive 
    
}
  export default CustomerExecutiveService;
